import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import IconReviewStar from '../IconReviewStar/IconReviewStar';

import css from './ListingRating.module.css';

const ListingRating = props => {
  const { average = 0, count = 0, className, rootClassName, hideEmpty = false } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (!count) {
    return hideEmpty ? null : (
      <span className={classes}>
        <FormattedMessage id="ListingRating.empty" />
      </span>
    );
  }

  const label = Number(average).toFixed(1);
  return (
    <span className={classes} title={`${label}/5`}>
      <IconReviewStar className={css.star} isFilled ariaLabel={`${label}/5`} />
      <span className={css.average}>{label}</span>
      <span className={css.count}>
        <FormattedMessage id="ListingRating.count" values={{ count }} />
      </span>
    </span>
  );
};

export default ListingRating;
